import React from 'react';
import { motion } from 'framer-motion';

// Apple-style easing curve
const appleEase = [0.16, 1, 0.3, 1];

// Fade up animation - Apple style
export const FadeUp = ({ children, delay = 0, className = '' }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-10%' }}
      transition={{
        duration: 0.8,
        delay,
        ease: appleEase,
      }}
      className={className}
    >
      {children}
    </motion.div>
  );
};

// Grow in animation - for products
export const GrowIn = ({ children, delay = 0, className = '' }) => {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.92 }}
      whileInView={{ opacity: 1, scale: 1 }}
      viewport={{ once: true, margin: '-10%' }}
      transition={{
        duration: 1.0,
        delay,
        ease: appleEase,
      }}
      className={className}
    >
      {children}
    </motion.div>
  );
};

// Simple fade animation
export const Fade = ({ children, delay = 0, className = '' }) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true, margin: '-10%' }}
      transition={{
        duration: 0.8,
        delay,
        ease: appleEase,
      }}
      className={className}
    >
      {children}
    </motion.div>
  );
};

// Hero text reveal - on page load
export const HeroReveal = ({ children, delay = 0, className = '' }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{
        duration: 1,
        delay,
        ease: appleEase,
      }}
      className={className}
    >
      {children}
    </motion.div>
  );
};

// Product image crossfade
export const ProductFade = ({ children, className = '' }) => {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.95 }}
      transition={{
        duration: 0.5,
        ease: appleEase,
      }}
      className={className}
    >
      {children}
    </motion.div>
  );
};

export default FadeUp;
